module.exports = __webpack_public_path__ + "Pe-icon-7-stroked41d.71394c0c7ad6c1e7d5c7.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/pe-icon-7-stroke/fonts/Pe-icon-7-stroked41d.eot
// module id = ../../../../../src/assets/pe-icon-7-stroke/fonts/Pe-icon-7-stroked41d.eot
// module chunks = styles